export default {"src":"/_next/static/media/arrow_blue_previous.d08643b0.svg","height":21,"width":11};